import React, { FC, ReactElement, } from "react";
import ReactMarkdown from "react-markdown";
import raw from "raw.macro";

import { Modal, } from "components/FormControls";

export enum HelpModalType {
    Health = "health",
    Willpower = "willpower",
};

type Props = {
    type: HelpModalType,
    onCancel: () => void;
};

export const HelpModal:FC<Props> = (props: Props): ReactElement => {
    const { type, onCancel, } = props;

    const title = getTitle(type);
    const markdown = (type === HelpModalType.Health)
        ? raw("./help/health.md")
        : raw("./help/willpower.md");

    return (
        <Modal title={title} onCancel={onCancel}>
            <ReactMarkdown>{markdown}</ReactMarkdown>
        </Modal>
    );
};

const getTitle = (type: HelpModalType): string => {
    return (type === HelpModalType.Health)
        ? "Health Tracker Help"
        : "Willpower Tracker Help";
}
